(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-tab"] = factory();
	else
		root["vue-tab"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 626:
/***/ (function(module) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})((typeof self !== 'undefined' ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __nested_webpack_require_524__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__nested_webpack_require_524__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__nested_webpack_require_524__.o(definition, key) && !__nested_webpack_require_524__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__nested_webpack_require_524__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__nested_webpack_require_524__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __nested_webpack_exports__ = {};

// EXPORTS
__nested_webpack_require_524__.d(__nested_webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __nested_webpack_require_524__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueTablePager.vue?vue&type=template&id=105fceb1&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-table-pager",class:`sf-table-pager--${_vm.backgroundColor}`},[_c('button',{staticClass:"sf-table-pager__btn sf-table-pager__btn--prev",attrs:{"title":_vm.$t('prevLabel'),"aria-label":_vm.$t('prevLabel'),"type":"button","disabled":_vm.isPrevDisabled},on:{"click":_vm.handleMoveToPrev}},[_c('span',{staticClass:"sr-only"},[_vm._t("prev-label",function(){return [_vm._v(_vm._s(_vm.$t('prevLabel')))]})],2)]),_c('div',{staticClass:"sf-table-pager__heading",attrs:{"aria-live":"polite","aria-atomic":"true"}},[_vm._l((_vm.columns),function(column,index){return [(_vm.activeColumn == column)?[_vm._t(column)]:_vm._e()]})],2),_c('button',{staticClass:"sf-table-pager__btn sf-table-pager__btn--next",attrs:{"title":_vm.$t('nextLabel'),"aria-label":_vm.$t('nextLabel'),"type":"button","disabled":_vm.isNextDisabled},on:{"click":_vm.handleMoveToNext}},[_c('span',{staticClass:"sr-only"},[_vm._t("next-label",function(){return [_vm._v(_vm._s(_vm.$t('nextLabel')))]})],2)])])
}
var staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/VueTablePager.lang.json
const VueTablePager_lang_namespaceObject = JSON.parse('{"en":{"prevLabel":"Previous Item","nextLabel":"Next Item"},"hu":{"prevLabel":"Previous Item","nextLabel":"Next Item"}}');
;// CONCATENATED MODULE: ./src/components/constants.js
const BGCOLOR = {
	GRAY: 'gray',
	WHITE: 'white'
};

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueTablePager.vue?vue&type=script&lang=js&




/* harmony default export */ const VueTablePagervue_type_script_lang_js_ = ({
	name: 'VueTablePager',
	data: () => ({
		columns: [],
		currentColumn: 0,
		activeColumn: null
	}),
	props: {
		/**
		 * @model
		 */
		value: {
			required: true
		},
		/**
		 * Sets the background color
		 * @values gray, white
		 */
		backgroundColor: {
			type: String,
			required: false,
			default: BGCOLOR.GRAY,
			validator(val) {
				return Object.values(BGCOLOR).includes(val);
			}
		}
	},
	i18n: { messages: VueTablePager_lang_namespaceObject },
	watch: {
		activeColumn(val) {
			this.$emit('input', val);
		},
		value: {
			handler(val) {
				if (val) {
					this.activeColumn = val;
				} else {
					if (this.columns && this.columns.length) {
						this.activeColumn = this.columns[0];
					}
				}
			},
			immediate: true
		},
		columns(val) {
			if (val && val.length && this.activeColumn == null) {
				this.activeColumn = this.columns[0];
			}
		}
	},
	methods: {
		handleMoveToPrev() {
			if (!this.isPrevDisabled) {
				this.activeColumn = this.columns[this.indexOfActiveColumn - 1];
			}
		},
		handleMoveToNext() {
			if (!this.isNextDisabled) {
				this.activeColumn = this.columns[this.indexOfActiveColumn + 1];
			}
		}
	},
	computed: {
		numberOfColumns() {
			return this.columns.length;
		},
		indexOfActiveColumn() {
			return this.columns.indexOf(this.activeColumn);
		},
		isPrevDisabled() {
			return !this.indexOfActiveColumn;
		},
		isNextDisabled() {
			return this.indexOfActiveColumn + 1 == this.numberOfColumns;
		}
	},
	mounted() {
		this.columns = Object.keys(this.$slots);
	}
});

;// CONCATENATED MODULE: ./src/components/VueTablePager.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueTablePagervue_type_script_lang_js_ = (VueTablePagervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-58.use[3]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueTablePager.vue?vue&type=style&index=0&id=105fceb1&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/VueTablePager.vue?vue&type=style&index=0&id=105fceb1&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueTablePager.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueTablePagervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "105fceb1",
  null
  
)

/* harmony default export */ const VueTablePager = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueTablePager);


__nested_webpack_exports__ = __nested_webpack_exports__["default"];
/******/ 	return __nested_webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-table-pager.umd.js.map

/***/ }),

/***/ 965:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


/**
 * Module dependencies.
 */

var trim = __webpack_require__(130);

/**
 * Parse the given query `str`.
 *
 * @param {String} str
 * @return {Object}
 * @api public
 */

exports.parse = function(str){
  if ('string' != typeof str) return {};

  str = trim(str);
  if ('' == str) return {};

  var obj = {};
  var pairs = str.split('&');
  for (var i = 0; i < pairs.length; i++) {
    var parts = pairs[i].split('=');
    obj[parts[0]] = null == parts[1]
      ? ''
      : decodeURIComponent(parts[1]);
  }

  return obj;
};

/**
 * Stringify the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api public
 */

exports.stringify = function(obj){
  if (!obj) return '';
  var pairs = [];
  for (var key in obj) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
  }
  return pairs.join('&');
};


/***/ }),

/***/ 130:
/***/ ((module, exports) => {

exports = module.exports = trim;

function trim(str){
  if (str.trim) return str.trim();
  return exports.right(exports.left(str));
}

exports.left = function(str){
  if (str.trimLeft) return str.trimLeft();

  return str.replace(/^\s\s*/, '');
};

exports.right = function(str){
  if (str.trimRight) return str.trimRight();

  var whitespace_pattern = /\s/,
      i = str.length;
  while (whitespace_pattern.test(str.charAt(--i)));

  return str.slice(0, i + 1);
};


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueTab.vue?vue&type=template&id=7d241792&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-tab",class:`sf-tab--${_vm.backgroundColor} ${_vm.layoutType != 'default' ? 'sf-tab--' + _vm.layoutType : ''}`},[(_vm.isMobile)?[(_vm.mobileView == _vm.MOBILE_VIEWS.SELECT)?_c('div',{staticClass:"sf-tab__select-wrapper"},[_c('select',{staticClass:"sf-tab__select",class:[_vm.selectColor ? _vm.setSelectColor : ''],attrs:{"role":"tablist","aria-label":_vm.label ? _vm.label : false},on:{"change":function($event){return _vm.handleTabChangeOnClick($event.target.value)}}},_vm._l((_vm.tabNames),function(tabIndex,index){return _c('option',{key:'mobile-select-' + _vm.uuid + '-' + index,attrs:{"role":"tab","aria-selected":_vm.activeTabIndex == index ? 'true' : 'false',"aria-controls":'sf-tab-panel-' + _vm.uuid + '-' + index,"id":'sf-tab-head-' + _vm.uuid + '-' + index},domProps:{"value":index,"selected":_vm.activeTabIndex == index}},[_vm._t('tab-head-' + tabIndex)],2)}),0),_c('svg',{staticClass:"sf-tab__select-icon",attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 9L12 17L20 9","stroke":"#52AE30","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])]):_vm._e(),(_vm.mobileView == _vm.MOBILE_VIEWS.PAGER)?_c('div',{staticClass:"sf-tab__pager-wrapper"},[_c('VueTablePager',{attrs:{"backgroundColor":"white"},model:{value:(_vm.selectedMobilePage),callback:function ($$v) {_vm.selectedMobilePage=$$v},expression:"selectedMobilePage"}},[_vm._l((_vm.tabNames),function(tabIndex,index){return _vm._t('tab-head-' + tabIndex,null,{"slot":'tab-head-' + tabIndex})})],2)],1):_vm._e(),(_vm.mobileView == _vm.MOBILE_VIEWS.PILLS)?_c('div',{staticClass:"sf-tab-pills__wrapper"},[_c('div',{staticClass:"sf-tab-pills__active-tab",style:({ width: _vm.activeTabWidth, left: _vm.activeTabTranslateLeft })}),_c('ul',{staticClass:"sf-tab-pills__head",attrs:{"role":"tablist","aria-label":_vm.label ? _vm.label : false}},_vm._l((_vm.tabNames),function(tabIndex,index){return _c('li',{key:'mobile-pills-' + _vm.uuid + '-' + index,ref:"tab-head",refInFor:true,staticClass:"sf-tab-pills__head-item",class:{ 'sf-tab-pills__head-item--active': _vm.activeTabIndex == index },style:({ 'flex-basis': _vm.activeTabWidth }),attrs:{"role":"tab","tabindex":_vm.activeTabIndex == index ? 0 : -1,"aria-selected":_vm.activeTabIndex == index ? 'true' : 'false',"aria-controls":'sf-tab-panel-' + _vm.uuid + '-' + index,"id":'sf-tab-head-' + _vm.uuid + '-' + index},on:{"click":function($event){return _vm.handleTabChangeOnClick(index)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"]))return null;if('button' in $event && $event.button !== 2)return null;return _vm.handleMoveToRight.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"]))return null;if('button' in $event && $event.button !== 0)return null;return _vm.handleMoveToLeft.apply(null, arguments)}]}},[_c('span',{staticClass:"sf-tab-pills__head-item-inner"},[_vm._t('tab-head-' + tabIndex)],2)])}),0)]):_vm._e()]:_vm._e(),(!_vm.isMobile)?[(_vm.desktopView == _vm.DESKTOP_VIEWS.TAB)?_c('ul',{staticClass:"sf-tab__head",class:_vm.tabHeadItemPadding.includes('large') ? 'sf-tab__head--page-level' : '',attrs:{"role":"tablist","aria-label":_vm.label ? _vm.label : false}},_vm._l((_vm.tabNames),function(tabIndex,index){return _c('li',{key:'desktop-head-' + _vm.uuid + '-' + index,ref:"tab-head",refInFor:true,staticClass:"sf-tab__head-item",class:[{ 'sf-tab__head-item--active': _vm.activeTabIndex == index }, _vm.tabHeadItemPadding == 'small-compact' ? 'sf-tab__head-item--compact' : _vm.tabHeadItemPadding == 'medium-large' ? 'sf-tab__head-item--page-level' : _vm.tabHeadItemPadding == 'large' ? 'sf-tab__head-item--page-level-large' : ''],attrs:{"role":"tab","tabindex":_vm.activeTabIndex == index ? 0 : -1,"aria-selected":_vm.activeTabIndex == index ? 'true' : 'false',"aria-controls":'sf-tab-panel-' + _vm.uuid + '-' + index,"id":'sf-tab-head-' + _vm.uuid + '-' + index},on:{"click":function($event){return _vm.handleTabChangeOnClick(index)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"]))return null;if('button' in $event && $event.button !== 2)return null;return _vm.handleMoveToRight.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"]))return null;if('button' in $event && $event.button !== 0)return null;return _vm.handleMoveToLeft.apply(null, arguments)}]}},[(_vm.activeTabIndex === index && _vm.activeTabIndex != 0)?_c('div',{staticClass:"sf-tabs__tab-head-corner sf-tabs__tab-head-corner--left",attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.activeTabIndex === index || _vm.tabNames.length - 1 === index)?_c('div',{staticClass:"sf-tabs__tab-head-corner sf-tabs__tab-head-corner--right",attrs:{"aria-hidden":"true"}}):_vm._e(),_c('div',{staticClass:"sf-tab__head-item-inner"},[_vm._t('tab-head-' + tabIndex)],2)])}),0):_vm._e(),(_vm.desktopView == _vm.DESKTOP_VIEWS.PILLS)?_c('div',{staticClass:"sf-tab-pills__wrapper"},[_c('div',{staticClass:"sf-tab-pills__active-tab",style:({ width: _vm.activeTabWidth, left: _vm.activeTabTranslateLeft })}),_c('ul',{staticClass:"sf-tab-pills__head",attrs:{"role":"tablist","aria-label":_vm.label ? _vm.label : false}},_vm._l((_vm.tabNames),function(tabIndex,index){return _c('li',{key:index,ref:"tab-head",refInFor:true,staticClass:"sf-tab-pills__head-item",class:{ 'sf-tab-pills__head-item--active': _vm.activeTabIndex == index },style:({ 'flex-basis': _vm.activeTabWidth }),attrs:{"role":"tab","tabindex":_vm.activeTabIndex == index ? 0 : -1,"aria-controls":'sf-tab-panel-' + _vm.uuid + '-' + index,"aria-selected":_vm.activeTabIndex == index ? 'true' : 'false',"id":'sf-tab-head-' + _vm.uuid + '-' + index},on:{"click":function($event){return _vm.handleTabChangeOnClick(index)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"]))return null;if('button' in $event && $event.button !== 2)return null;return _vm.handleMoveToRight.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"]))return null;if('button' in $event && $event.button !== 0)return null;return _vm.handleMoveToLeft.apply(null, arguments)}]}},[_c('span',{staticClass:"sf-tab-pills__head-item-inner"},[_vm._t('tab-head-' + tabIndex)],2)])}),0)]):_vm._e()]:_vm._e(),_vm._l((_vm.tabNames),function(tabIndex,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTabIndex == index),expression:"activeTabIndex == index"}],key:'panel-' + _vm.uuid + '-' + index,ref:"panelRefs",refInFor:true,staticClass:"sf-tab__panel",class:[{ 'sf-tab__panel--first-active': _vm.activeTabIndex == 0 }, { 'sf-tab__panel--has-padding': _vm.hasPadding }],attrs:{"role":"tabpanel","tabindex":"0","id":'sf-tab-panel-' + _vm.uuid + '-' + index,"aria-labelledby":'sf-tab-head-' + _vm.uuid + '-' + index}},[_vm._t('tab-panel-' + tabIndex)],2)})],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ../../node_modules/querystring-component/index.js
var querystring_component = __webpack_require__(965);
;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

;// CONCATENATED MODULE: ./src/components/constants.js
const BGCOLOR = ['gray', 'white'];
const SELECT_COLOR = ['dark-gray'];
const TAB_HEAD_PADDING = ['small-compact', 'medium-normal', 'medium-large', 'large'];
const MOBILE_VIEWS = {
	SELECT: 'select',
	PAGER: 'pager',
	PILLS: 'pills'
};
const DESKTOP_VIEWS = {
	TAB: 'tab',
	PILLS: 'pills'
};

// EXTERNAL MODULE: ../../node_modules/@ui-common/vue-table-pager/dist/vue-table-pager.umd.js
var vue_table_pager_umd = __webpack_require__(626);
var vue_table_pager_umd_default = /*#__PURE__*/__webpack_require__.n(vue_table_pager_umd);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueTab.vue?vue&type=script&lang=js&





const LAYOUT_TYPE = {
	DEFAULT: 'default',
	RELATED: 'related'
};

/* harmony default export */ const VueTabvue_type_script_lang_js_ = ({
	name: 'VueTab',
	data: () => ({
		activeTabIndex: 0,
		selectedMobilePage: null,
		tabNames: [],
		observer: null,
		anchorRelations: []
	}),
	props: {
		/**
		 * Id of the tabs
		 */
		id: {
			required: false,
			type: String,
			default: 'tab-module'
		},
		/**
		 * Label (aria-label) of the tabs
		 */
		label: {
			required: false,
			type: String
		},
		/**
		 * Specify the number of the initial active tab
		 */
		initTabIndex: {
			type: Number,
			default: 0
		},
		/**
		 * Background color of the tab-head & tab-content
		 */
		backgroundColor: {
			type: String,
			required: false,
			default: 'gray',
			validator(val) {
				return BGCOLOR.includes(val);
			}
		},
		/**
		 * Background color of select on mobile
		 */
		selectColor: {
			type: String,
			required: false,
			validator(val) {
				return SELECT_COLOR.includes(val);
			}
		},
		/**
		 * Specify whether the content has padding or not
		 */
		hasPadding: {
			type: Boolean,
			required: false,
			default: true
		},
		/**
		 * Specify layout type on mobile (normal / inner tab)
		 */
		layoutType: {
			type: String,
			required: false,
			default: LAYOUT_TYPE.DEFAULT
		},
		/**
		 * Padding of the tab-head-item
		 */
		tabHeadItemPadding: {
			type: String,
			required: false,
			default: 'medium-normal',
			validator(val) {
				return TAB_HEAD_PADDING.includes(val);
			}
		},
		/**
		 * How to display the tab heads on mobile screens
		 */
		mobileView: {
			type: String,
			required: false,
			default: 'select',
			validator(val) {
				return Object.values(MOBILE_VIEWS).includes(val);
			}
		},
		desktopView: {
			default: 'tab',
			validator(val) {
				return Object.values(DESKTOP_VIEWS).includes(val);
			}
		}
	},
	mixins: [a, l],
	watch: {
		activeTabIndex(val) {
			this.$emit('change', val);
			if (this.mobileView == 'pager') {
				this.selectedMobilePage = `tab-head-${val}`;
			}
		},
		selectedMobilePage: {
			handler(val) {
				this.activeTabIndex = this.columns.indexOf(val);
			},
			immediate: true
		}
	},
	methods: {
		handleTabChangeOnClick(index) {
			this.activeTabIndex = parseInt(index, 10);
		},
		handleMoveToLeft() {
			if (this.activeTabIndex != 0) {
				this.$refs['tab-head'][this.activeTabIndex - 1].focus();
				this.activeTabIndex--;
			} else {
				this.$refs['tab-head'][this.tabNames.length - 1].focus();
				this.activeTabIndex = this.tabNames.length - 1;
			}
		},
		handleMoveToRight() {
			if (this.activeTabIndex + 1 !== this.tabNames.length) {
				this.$refs['tab-head'][this.activeTabIndex + 1].focus();
				this.activeTabIndex++;
			} else {
				this.$refs['tab-head'][0].focus();
				this.activeTabIndex = 0;
			}
		},
		initObserver() {
			const config = {
				subtree: true,
				childList: true
			};
			const vm = this;
			const callback = () => {
				vm.$nextTick(() => {
					this.tabNames = Object.keys(this.$slots)
						.filter((slot) => slot.includes('tab-panel'))
						.map((slotName) => slotName.split('-').pop());
					if (this.activeTabIndex >= this.tabNames.length) {
						this.activeTabIndex = this.tabNames.length - 1;
					}
				});
			};
			const observer = new MutationObserver(callback);
			observer.observe(this.$el, config);
			this.observer = observer;
		},
		gatherAnchorRelations() {
			const anchors = [];
			const bookmarks = [];
			this.$refs.panelRefs.forEach((ref, index) => {
				anchors.push(...[...ref.querySelectorAll('a[href^="#"]')].map((anchor) => ({ anchor, anchorIndex: index })));
				bookmarks.push(...[...ref.querySelectorAll('a[class="bookmark"]')].map((bookmark) => ({ bookmark, bookmarkIndex: index })));
			});
			bookmarks.forEach(({ bookmark, bookmarkIndex }) => {
				let hasRelation = false;
				anchors.forEach(({ anchor, anchorIndex }) => {
					if (anchor.href?.endsWith(bookmark.id)) {
						this.anchorRelations.push({ anchor, anchorIndex, bookmark, bookmarkIndex });
						hasRelation = true;
					}
				});
				if (!hasRelation) {
					this.anchorRelations.push({ anchor: null, anchorIndex: null, bookmark, bookmarkIndex });
				}
			});
		},
		addTabSwitchToAnchors() {
			for (const { anchor, anchorIndex, bookmarkIndex } of this.anchorRelations) {
				if (anchor === null || anchorIndex === null) {
					continue;
				}
				if (anchorIndex !== bookmarkIndex) {
					anchor.addEventListener('click', () => {
						this.activeTabIndex = bookmarkIndex;
					});
				}
			}
		},
		switchTabByHash() {
			const hash = window.location.hash.substring(1);
			if (hash) {
				for (const { bookmark, bookmarkIndex } of this.anchorRelations) {
					if (bookmark.id === hash) {
						this.activeTabIndex = bookmarkIndex;
						break;
					}
				}
			}
		}
	},
	components: {
		VueTablePager: (vue_table_pager_umd_default())
	},
	computed: {
		MOBILE_VIEWS: () => MOBILE_VIEWS,
		DESKTOP_VIEWS: () => DESKTOP_VIEWS,
		columns() {
			return Object.keys(this.$slots).filter((slot) => slot.startsWith('tab-head'));
		},
		setSelectColor() {
			return 'sf-tab__select--' + this.selectColor;
		},
		activeTabWidth() {
			return `${100 / this.tabNames.length}%`;
		},
		activeTabTranslateLeft() {
			return `${(100 / this.tabNames.length) * this.activeTabIndex}%`;
		}
	},
	created() {
		const params = querystring_component.parse(window.location.search.substring(1));
		const tabIndexParam = params[`${this.id}-index`] && parseInt(params[`${this.id}-index`], 10);
		if (!isNaN(tabIndexParam)) {
			this.activeTabIndex = tabIndexParam;
		} else {
			this.activeTabIndex = this.initTabIndex;
		}
		this.tabNames = Object.keys(this.$slots)
			.filter((slot) => slot.includes('tab-panel'))
			.map((slotName) => slotName.split('-').pop());
	},
	mounted() {
		this.initObserver();
		this.gatherAnchorRelations();
		this.addTabSwitchToAnchors();
		this.switchTabByHash();
	},
	beforeDestroy() {
		this.observer.disconnect();
	}
});

;// CONCATENATED MODULE: ./src/components/VueTab.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueTabvue_type_script_lang_js_ = (VueTabvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-62.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-62.use[1]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-62.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-62.use[3]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueTab.vue?vue&type=style&index=0&id=7d241792&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/VueTab.vue?vue&type=style&index=0&id=7d241792&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueTab.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueTabvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "7d241792",
  null
  
)

/* harmony default export */ const VueTab = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueTab);


})();

__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-tab.umd.js.map